import { render, staticRenderFns } from "./profitsAndLosses.vue?vue&type=template&id=1b6e3e64"
import script from "./profitsAndLosses.vue?vue&type=script&lang=js"
export * from "./profitsAndLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports